<template>
  <div class="home-content-page-v" style="display:block">
    <div class="content-1">
      <div class="gu-duan">
        <el-select v-model="oilStation" filterable placeholder="请选择加油站">
          <el-option v-for="item in oilStations" :key="item" :label="item" :value="item">
          </el-option>
        </el-select>
      </div>
      <div class="content-1-tables">
        <div class="content-1-table-1 mii-table">
          <content-title title="进销存数据"></content-title>
          <table style="width: 100%;background: #fff;">
            <thead>
              <tr>
                <th>店名</th>
                <th>商品</th>
                <th>时间</th>
                <th>期初库存</th>
                <th>入库量</th>
                <th>出库量</th>
                <th>期末库存</th>
                <th>空容</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(data, index) in showData">
                <td :rowspan="value.rowspan || 1" v-for="value in data.slice(0, 8)" :class="{'data-td': !value.label, 's-bak-td': !value.label && (index % 3 === 1)}" v-if="value.rowspan !== 0">{{value.label || value}}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="content-1-table-2 mii-table">
          <content-title title="预测结果"></content-title>
          <table style="width: 100%;background: #fff;">
            <thead>
              <tr>
                <th>平均销量</th>
                <th>消耗率</th>
                <th>断货时间点</th>
                <th>在途时间(H)</th>
                <th>订单紧急程度</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(data, index) in showData">
                <td v-for="value in data.slice(8)" :class="{'s-bak-td': !value.label && (index % 3 === 1)}" v-if="value.rowspan !== 0">{{value.label || value}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="content-2">
      <div class="content-2-table mii-table">
        <content-title :title="'每日订单（' + day + '）'"></content-title>
        <table style="width: 100%;background: #fff;">
          <thead>
            <tr>
              <th>订单类型</th>
              <th>点名</th>
              <th>区域</th>
              <th>商品</th>
              <th>空容</th>
              <th>平均销量</th>
              <th>断货时间点</th>
              <th>在途时间(H)</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(data, index) in preDayData.slice(start_index, start_index + 10)">
              <td :rowspan="value.rowspan || 1" v-for="value in data.slice(1)" :class="{'jj-bak-td': value === '紧急订单', 'ps-bak-td': value === '可配送订单'}" v-if="value.rowspan !== 0">{{value.label || value}}</td>
            </tr>
          </tbody>
        </table>
        <div class="content-2-page">
          <el-pagination small layout="prev, pager, next" v-on:current-change="pageChange" :page-size="row_num" :total="preDayData.length">
          </el-pagination>
          
        </div>
      </div>
      <div class="content-2-note" v-if="showNote">
        日销量预测分析步骤：<br>
        1.时间趋势检验：通过线图以及Dickey-Fuller对数据进行检验，如果时间趋势不稳定，则需要对数据进行分解和转换。<br>
        2.自相关，偏相关函数分析，选择匹配时间序列数据的模型 - ARIMA<br>
        3.模型拟合以及检验：用RStudio中tseries已经forecast程序包进行分析，检验和预测。模型检验参数赤池信息法(AIC)，贝叶斯信息法(BIC)数值最终用来判断模型的拟合。<br>
        订单紧急程度划分说明：<br>
        1.可配送订单：24小时<断货时间点≤48小时；<br>
        1.紧急订单：断货时间点≤24小时。
      </div>
      <div class="content-2-btn">
        <div class="btn-top-jiao">

        </div>
        <a href="javascript:;" @click="showNote = !showNote">预<br>测<br>分<br>析<br>方<br>法</a>
        <div class="btn-bottom-jiao">
        </div>
      </div>
    </div>
    <div style="display: none">
      {{preData}}
    </div>
  </div>
</template>

<script>
  import ContentTitle from '@/components_bit/ContentTitle'

  export default {
    name: 'cars',
    data () {
      return {
        start_index: 0,
        showNote: false,
        row_num: 10,
        day: ''
      }
    },
    components: {
      ContentTitle
    },
    methods: {
      pageChange (currentPage) {
        this.start_index = (currentPage - 1) * this.row_num
      }
    },
    computed: {
      showData: {
        get () {
          let data = []
          if (this.preData) {
            let vm = this
            this.preData.forEach(function (item) {
              if (item.oil === vm.oilStation) {
                data = item.data
              }
            })
            if (data[0] && data[0][0] && data[0][0].label) {
              return data
            }
            let row1 = {}
            let row2 = {}
            data.forEach(function (item, index) {
              let data1 = item[0]
              if (!row1[data1]) {
                row1[data1] = {index: index, data: {label: data1, rowspan: 1}}
              } else {
                row1[data1].data.rowspan ++
                item[0] = {label: data1, rowspan: 0}
              }
              let data2 = item[1]
              if (!row2[data2]) {
                row2[data2] = {index: index, data: {label: data2, rowspan: 1}}
              } else {
                row2[data2].data.rowspan ++
                item[1] = {label: data2, rowspan: 0}
              }
            })
            for (let key in row1) {
              data[row1[key].index][0] = row1[key].data
            }
            for (let key in row2) {
              data[row2[key].index][1] = row2[key].data
            }
          }
          return data
        }
      },
      showDayData: {
        get () {
          let data = []
          if (this.preDayData.length > 0) {
            data = this.preDayData
            if (data[0] && data[0][0] && data[0][0].label) {
              return data
            }
            let row1 = {}
            data.forEach(function (item, index) {
              let data1 = item[0]
              if (!row1[data1]) {
                row1[data1] = {index: index, data: {label: data1, rowspan: 1}}
              } else {
                row1[data1].data.rowspan ++
                item[0] = {label: data1, rowspan: 0}
              }
            })
            for (let key in row1) {
              data[row1[key].index][0] = row1[key].data
            }
          }
          return data
        }
      },
      preData: {
        get () {
          return this.$store.getters.preData
        }
      },
      preStatus: {
        get () {
          return this.$store.getters.preStatus
        }
      },
      preDayData: {
        get () {
          let vm = this
          let newData = []
          let data = this.$store.getters.preDayData
          this.day = data.length > 0 ? data[0][0] : ''
          data.forEach(function (item) {
            if (item[0] === vm.day) {
              newData.push(item)
            }
          })
          return newData
        }
      },
      oilStation: {
        get () {
          return this.$store.getters.oilStation
        },
        set (value) {
          return this.$store.dispatch('setOilStation', value)
        }
      },
      oilStations: {
        get () {
          return this.$store.getters.oilStations
        }
      }
    },
    created () {
      if (!this.$store.getters.preData || this.$store.getters.preData.length === 0) {
        this.$store.dispatch('loadPreData', 'prediction_to.json')
      }
    }
  }
</script>

<style scoped lang="less">
  @import '../../style/base.less';
  .content-2-page {
    display: flex;
    justify-content: flex-end;
  }
  .btn-top-jiao {
    width: 0;
    height: 0;
    border-bottom: 0.81em solid #486881;
    border-left: 1.7em solid transparent;
  }
  .btn-bottom-jiao {
    width: 0;
    height: 0;
    border-top: 0.81em solid #486881;
    border-right: 1.7em solid transparent;
  }
  .content-2 {
    padding: 1.88em 0 4.8em 0.7em;
    display: flex;
    justify-content: space-between;
    background: #e0e0e0;
    border-radius: 0.5em;
    border-top: 2px dashed #bbb;
  }
  .content-2-table {
    background: #fff;
    width: 68%;
  }
  .content-2-note {
    .content-shadow;
    .content-top-radius;
    .content-bottom-radius;
    padding: 2em 1.5em;
    color: #081633;
    line-height: 1.9;
    font-size: 0.8em;
    margin: 0 0.7em 0 1.88em;
    background: #fff;
    flex: 1;
  }
  .content-2-btn {
    width: 1.7em;
    line-height: 1.1;
    display: flex;
    flex-direction:column;
    text-align: center;
    a {
      font-size: 0.8em;
      color: #fff;
      background: #486881;

    }
  }
  .content-1-table-1 {
    width: 68%;
  }
  .content-1-table-2 {
    flex: 1;
    background:#fff;
    margin-left: 0.7em;
    display: flex;
    flex-direction:column;
  }
  .gu-duan {
    margin-bottom:0.7em;
    width: 100%;
    .el-select {
      width: 25em;
    }
  }
  .content-1 {
    border-radius: 0.5em;
    padding: 0.88em 0.7em 2.25em;
    background-color: #e5e5e5;
    display: flex;
    flex-direction:column;
  }
  .content-1-tables {
    display: flex;
  }
  .mii-table-1 {
    background-color: @bak-color-td-2;
  }
  .mii-table-2 {
    background-color: @bak-color-td-1;
  }
  .pagination-table {
    text-align: right;
    margin-right: 0.5em;
  }
  .mii-table {
    .content-shadow;
    .content-top-radius;
    display: flex;
    flex-direction:column;
    box-shadow: 1px 2px 4px rgba(0, 0, 0, 0.3);
    .data-td {
      width: 10%;
    }
    .s-bak-td {
      background-color: #e0e6ea;
      border:0 solid @bak-color-main;
    }
    .jj-bak-td {
      background-color: @bak-color-2;
      color: #00ccff;
    }
    .ps-bak-td {
      background-color: #98aab9;
    }
    table {
      border-spacing: 0px;
      width: 100%;
      th {
        border:0.2px solid @bak-color-main;
        text-align: center;
        font-size: 0.8em;
        line-height: 2.5em;
        color: @bak-color-1;
        font-weight: 100;
        word-break:keep-all;
        white-space:nowrap;
        text-overflow:ellipsis;
      }
      td {
        border:0.2px solid @bak-color-main;
        text-align: center;
        font-size: 0.8em;
        line-height: 2.5em;
        color: @bak-color-1;
        word-break:keep-all;
        white-space:nowrap;
        text-overflow:ellipsis;
      }
    }
  }
</style>

<style lang="less">
  .gu-duan .el-select .el-input .el-input__icon {
    background: #081633;
    color: #fff;
    width: 5em;
    transition: none;
  }
  .gu-duan .el-input__icon+.el-input__inner {
    padding-left: 2.3em;
  }
</style>



// WEBPACK FOOTER //
// prediction_to.vue?9a8aaed2